export default {
  homepage: "homepage"
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js